/* Handler for filter
!! Main function based on AlpineJS !!
========================================================================================== */


Alpine.data('mainProductFilter', () => ({
    init(){},

    // Reset all filters for type
    resetFilterType(type) {
        // Dispatch event to parent component
        Livewire.dispatch('resetFilterType', {type: type});
    },

    // Reset all filters single
    resetFilterSingle(type, key) {
        // Dispatch event to parent component
        Livewire.dispatch('resetFilterSingle', {type: type, key: key});
    },

    // Reset all filters
    resetFilterAll() {
        // Dispatch event to parent component
        Livewire.dispatch('resetFilterAll');
    },
}));
